import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { filterTag_template } from "./filterTag_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import { tagTypes } from "../../modules/tagTypes";

declare var ko: any;

export class headerMenu_template extends vnTemplate {

    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    public tagTypeFilter: filterAutocomplete_template;

    public contentTypeFilter: filterAutocomplete_template;

    protected getTemplateHtml(): string {
        return (

           /*html*/ `
            <div class="list-header w-justify">
                <div class="w-left">
                    <div class="form-body form-section faq">
                        <button class="btn secondary icon i-add" type="button" data-bind="event: { click: onClickAddHeaderMenu }"><span class="hide"></span>Add Menu</button>
                    </div>
                </div>
                <div class="w-center"></div>
                <div class="w-right"></div>
            </div>
            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none">Name</span></th>
                            <th><span class="icon list-sort-none">Display Logic</span></th>
                            <th><span class="icon list-sort-none">Created On</span></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: menus">
    
                        <tr  class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: displayLogic"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: dateCreated"></span></a></td>
                            <td>
                                <div class="w-right">
                                    <button data-bind="event: { click: $parent.onClickShowEdit}" class="btn only-icon icon i-edit" type="button" style="float: right; width: auto; padding-inline: .75rem;"><strong style="margin-left: .5rem;">Edit Website Logic</strong></button>
                                </div>
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
            
            `

        );
    }

    protected getTemplateName(): string {
        return "headerMenu_template";
    }


    protected initPartial() {
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller)
        this.pagination.getTemplateViewModel().itemPerPage = 10;
        
        this.tagTypeFilter = new filterAutocomplete_template("filterAutocompleteTagType_template", this.getTemplateViewModel(), this.caller);
        this.tagTypeFilter.setPlaceholderAndLabel( 'Tag Type' );
        this.tagTypeFilter.setIsShowCurrentSelection(false);
        this.tagTypeFilter.setAddNewOptionEnabled(false);

        this.contentTypeFilter = new filterAutocomplete_template("filterAutocompleteContentType_template", this.getTemplateViewModel(), this.caller);
        this.contentTypeFilter.setPlaceholderAndLabel( 'Content Type' );
        this.contentTypeFilter.setIsShowCurrentSelection(false);
    }

    protected buildViewModel(): any {
        let huit_neuf_this = this;
        return {
            menus : ko.observableArray([]),
            selectedMenuId: ko.observable(null),
            config: ko.observableArray(['Article', 'Hub Page']),
            selectedConfig: ko.observable('Article'),
            name: ko.observable(""),
            tagTypes: ko.observableArray([]),
            oldTagTypes: ko.observableArray([]),
            contentTypes: ko.observableArray([]),
            oldContentTypes: ko.observableArray([]),
            idField: ko.observable(null),
            onClickView : function (data, event) {
                huit_neuf_this.onClickView(data.id)
            },
            onClickShowEdit: function (data, event) {
                huit_neuf_this.onClickShowEdit(data, event)
            },
            onClickAddHeaderMenu: function (data, event){
                huit_neuf_this.onClickAddHeaderMenu(data, event)
            }

        }
    }


    public setMenu(menusObj, brandId){
        let menus = []
        for (let m of menusObj){
            menus.push({
                id: m.id,
                name: m.name,
                tagTypes: m.idTagTypes,
                contentTypes: m.idContentTypes,
                config: m.config,
                emakiEdit: '/brand/' + brandId + '/config/header-menu/sub-menu/edit/' + m.id,
                dateCreated: m.dateCreated,
                displayLogic : this.getDisplayLogicString(m.idContentTypes, m.idTagTypes)
            })
        }
        this.getTemplateViewModel().menus(menus)
    }

    public getDisplayLogicString(idContentTypes, idTagTypes) {
        if(idContentTypes.length == 0 && idTagTypes.length == 0){
            return 'Default';
        }else{
            let parts = [];
            if(idContentTypes.length > 0) parts.push('Content Types: ' + idContentTypes.length);
            if(idTagTypes.length > 0) parts.push('Tag Types: ' + idTagTypes.length);
            return parts.join(' | ');
        }
    }

    public onClickView(id: number) {

        this.caller.viewMenuItems(id);
    }

    public onClickAddHeaderMenu(data,event) {

        this.caller.addHeaderMenu();
    }

    protected setTagFilterAutocomplete(tags) {

        this.tagTypeFilter.getTemplateViewModel().tags(tags);
    }

    public setTagFilter(tags) {

        this.getTemplateViewModel().tagFilter.tags(tags);
    }

    private onClickShowEdit(data, event) {

        this.caller.redirectToEditPage(data);

    }

}


// WEBPACK FOOTER //
// ./js/components/templates/headerMenu_template.ts